import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import api from "../../lib/api";

const LucideIcon = ({ name, ...props }) => {
  const Ico = Icons[name] || Icons.Compass;
  return <Ico {...props} />;
};

export default function OpeningGuideTeaser() {
  const [steps, setSteps] = useState([]);
  useEffect(() => {
    api.get("/opening-guide").then((r) => setSteps(r.data || [])).catch(() => {});
  }, []);

  return (
    <section className="section-pad bg-softbg" data-testid="opening-guide-teaser">
      <div className="container-site">
        <div className="text-center mb-14">
          <p className="accent-script text-gold text-2xl mb-1">Uzman Rehber</p>
          <h2 className="heading-serif text-3xl md:text-4xl font-semibold text-navy">
            Otel Açılışınızı Adım Adım Planlayın
          </h2>
          <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
            Konseptten açılışa — 5 kritik aşamada yanınızda olan uzman rehberimiz.
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-4 relative">
          {/* Timeline line (desktop) */}
          <div className="hidden md:block absolute top-10 left-[10%] right-[10%] h-[2px] bg-gradient-to-r from-transparent via-[#d6b06b] to-transparent opacity-50" />

          {steps.map((s, i) => (
            <Link
              key={s.id}
              to={`/acilis-rehberi/${s.slug}`}
              className="relative bg-white rounded-xl p-6 border border-gray-100 hover:border-gold/40 hover:shadow-lg transition-all group"
              data-testid={`guide-step-${s.slug}`}
            >
              <div className="h-12 w-12 rounded-full bg-navy text-gold mx-auto flex items-center justify-center mb-4 relative z-10 group-hover:bg-gold group-hover:text-white transition-colors">
                <LucideIcon name={s.icon} size={20} />
              </div>
              <div className="text-[11px] uppercase tracking-wider text-gold font-medium text-center">
                Adım {i + 1}
              </div>
              <h3 className="heading-serif text-base font-semibold text-navy text-center mt-1 mb-2 min-h-[3rem]">
                {s.title_tr}
              </h3>
              <p className="text-xs text-gray-500 text-center line-clamp-3">{s.summary}</p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link to="/acilis-rehberi" className="btn-outline-gold" data-testid="guide-teaser-cta">
            Rehberin Tamamını İncele <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
